import * as React from "react";
import styled from "@emotion/styled";
import { BaseStyleAttrs } from "@/theme";
import classNames from "classnames";

export type InputRadioProps = {
  value: string;
  name: string;
  values: string[];
  isCssOverride?: boolean;
  checkedColor?: string;
  onChangeRadio: (key: string) => void;
} & BaseStyleAttrs &
  React.InputHTMLAttributes<HTMLInputElement>;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  &.inline {
    flex-direction: row;
  }
`;

const InputWrap = styled.div`
  display: flex;
  display: nowrap;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-size: 17px;
  font-weight: bold;
  color: #666;

  &.optionOverride {
    font-size: 14px;
    font-weight: 400;
  }
`;

const StyledInput = styled.input`
  height: 30px;
  width: 30px;
  background: white;
  border: 2px solid #efefef;
  cursor: pointer;
  float: left;
  margin-right: 10px;
  border-radius: 50%;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 5px;
    left: 5px;
    height: 20px;
    width: 20px;
    background: #3498db;
    border-radius: 50%;
    transition: all 0.1s;
    transform: scale(0);
    visibility: hidden;
  }

  &.checked:after {
    transform: scale(1);
    visibility: visible;
  }
`;

export const StyledRadioInput = styled.input<{ checkedColor?: string }>`
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  outline: none;
  background: #f2f2f2;
  margin-right: 10px;
  &:checked {
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      margin: 5px;
      width: 10px;
      height: 10px;
      background: ${({ checkedColor = "#43A0DF" }) => checkedColor};
      transform: scale(1);
      visibility: visible;
    }
  }
`;

const InputRadio = ({ name, values, value, isCssOverride, onChangeRadio, ...props }: InputRadioProps) => (
  <Wrapper>
    {values.map((v, i) => {
      const uuid = `radio-${name}-${i}`;
      const handleChangeValue = (key: string) => () => onChangeRadio(key);
      return (
        <InputWrap key={`radio-${i + 1}-${v}`}>
          {isCssOverride ? (
            <StyledRadioInput
              id={uuid}
              type="radio"
              name={name}
              value={v}
              checked={value === v}
              onChange={handleChangeValue(v)}
              {...props}
            />
          ) : (
            <StyledInput
              id={uuid}
              type="radio"
              name={name}
              value={v}
              checked={value === v}
              onChange={handleChangeValue(v)}
              {...props}
            />
          )}

          <StyledLabel
            htmlFor={uuid}
            className={classNames({
              optionOverride: isCssOverride,
            })}
          >
            {v}
          </StyledLabel>
        </InputWrap>
      );
    })}
  </Wrapper>
);

export default InputRadio;
